import script from "./purchasePackage.vue?vue&type=script&setup=true&lang=ts"
export * from "./purchasePackage.vue?vue&type=script&setup=true&lang=ts"

import "./purchasePackage.vue?vue&type=style&index=0&id=34a79c50&scoped=true&lang=stylus"

import exportComponent from "D:\\project\\web\\vysa_wifi_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34a79c50"]])

export default __exports__